export default "__VITE_ASSET__Bzr15cM9__"